module.exports = __webpack_public_path__ + "static/media/sellonline.e8e371e0.png";